/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Apikeys_Your_KeysInputs */

const en_settings_apikeys_your_keys = /** @type {(inputs: Settings_Apikeys_Your_KeysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your Keys`)
};

const zh_settings_apikeys_your_keys = /** @type {(inputs: Settings_Apikeys_Your_KeysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你的密钥`)
};

/**
* | output |
* | --- |
* | "Your Keys" |
*
* @param {Settings_Apikeys_Your_KeysInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_apikeys_your_keys = /** @type {((inputs?: Settings_Apikeys_Your_KeysInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Apikeys_Your_KeysInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_apikeys_your_keys(inputs)
	return zh_settings_apikeys_your_keys(inputs)
});
export { settings_apikeys_your_keys as "settings.apikeys.your_keys" }